'use client';

import type { ErrorPageProps } from '@/frontend-types';

import ErrorMessage from '@/components/error-message';

export default function ErrorPage({ error }: ErrorPageProps) {
  return <ErrorMessage error={error} />;
}
